module.exports = __webpack_public_path__ + "7df65b1d4ecdadaac15a42606bd70d85.png";